import React from 'react';
import './ErrorPage.css';

export default function ErrorPage() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div className="error-page" style={{ width: '80%' }}>
        <h1>404 - Page Not Found</h1>
        <p>The page you are looking for does not exist.</p>
        {/* <Link to="/pagenotfound">Take Survey Again</Link> */}
      </div>
    </div>
  );
}
